import { OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { ReplaySubject, combineLatest } from 'rxjs';
import { takeUntil, concatMap, take, tap } from 'rxjs/operators';
import { Selectors, Actions } from 'store/root-reducer';
import { QuickScansService } from 'modules/quick-scan/services/quick-scans.service';
import { SnackbarService } from 'app/services/snackbar.service';
import { ScreeningService } from 'modules/core/services/screening.service';
import { NoCreditWarningDialogService } from 'modules/shared/components/no-credit-warning-dialog/no-credit-warning-dialog.service';
import { SearchEngineTypeValue } from 'modules/shared/models/screening.models';
var QuickScanCardComponent = /** @class */ (function () {
    function QuickScanCardComponent(translateService, quickScansService, store, router, snackBar, screeningService, noCreditWarningDialogService, cdf) {
        this.translateService = translateService;
        this.quickScansService = quickScansService;
        this.store = store;
        this.router = router;
        this.snackBar = snackBar;
        this.screeningService = screeningService;
        this.noCreditWarningDialogService = noCreditWarningDialogService;
        this.cdf = cdf;
        this.unsubscribe$ = new ReplaySubject(1);
        this.customerTypes = ['INDIVIDUAL', 'CORPORATE'];
        this.isLoading = false;
        this.selectedCustomerType = this.customerTypes[0];
        this.isDisabledQuickScan = false;
    }
    QuickScanCardComponent.prototype.ngOnInit = function () {
    };
    QuickScanCardComponent.prototype.ngOnDestroy = function () {
        this.unsubscribe$.next(null);
        this.unsubscribe$.complete();
    };
    /**
     * Open the dialog for warning message when search engines' credit is finished
     * @method openNoCreditWarningDialog
     */
    QuickScanCardComponent.prototype.openNoCreditWarningDialog = function (noCreditSearchEngines) {
        var _this = this;
        var noCreditDialogData = {
            noCreditSearchEngines: noCreditSearchEngines,
            hideContinueButton: !!noCreditSearchEngines.length &&
                (noCreditSearchEngines.length === this.selectedEngines.split(',').length) ? true : false
        };
        this.noCreditWarningDialogService
            .showNoCreditWarning(noCreditDialogData)
            .pipe(takeUntil(this.unsubscribe$), take(1))
            .subscribe(function (userDecision) {
            if (userDecision === 'continue') {
                _this.quickScan(noCreditSearchEngines);
            }
        });
    };
    QuickScanCardComponent.prototype.setSelectedEngines = function (engines) {
        this.selectedEngines = engines;
    };
    QuickScanCardComponent.prototype.generateUUUID = function () {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = Math.random() * 16 | 0;
            var v = c === 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    };
    /**
     * When needs to process quick scan
     * Hoan:
     * Would it be better if we emit event here then call api from parrent page?
     * And move some methods in quickscan service and use search sevice instead
     * @method quickScan
     */
    QuickScanCardComponent.prototype.quickScan = function (noCreditSearchEngines) {
        var _this = this;
        this.isLoading = true;
        var uuid = this.generateUUUID();
        var screeningsToBeDone = noCreditSearchEngines && noCreditSearchEngines.length ?
            this.selectedEngines.split(',').filter(function (selectedEngine) {
                return !noCreditSearchEngines
                    .map(function (noCreditSearchEngine) { return noCreditSearchEngine.toLowerCase(); })
                    .includes(_this.screeningService.getSearchEngineLabel(selectedEngine).toLowerCase());
            }).join(',') :
            this.selectedEngines;
        combineLatest([
            this.store.select(Selectors.domain.getCurrentDomain),
            this.store.select(Selectors.billable.getNLP)
        ])
            .pipe(take(1), tap(function (_a) {
            var currentDomain = _a[0], nlpEnabled = _a[1];
            var engineTypes = _this.selectedEngines.split(',');
            var isNlpEnabled = nlpEnabled ? nlpEnabled.display : false;
            engineTypes.forEach(function (engine) {
                if ([SearchEngineTypeValue.INTERNET_SEARCH, SearchEngineTypeValue.OWN_NAME].indexOf(engine) < 0) {
                    _this.store.dispatch(new Actions.pusher.SetQuickscanSearch({
                        quickscan: {
                            id: uuid,
                            name: _this.name
                        },
                        search: {
                            engineType: engine,
                            id: uuid,
                        }
                    }));
                }
                else if (isNlpEnabled && engine === SearchEngineTypeValue.INTERNET_SEARCH) {
                    _this.store.dispatch(new Actions.pusher.SetQuickscanNlp({
                        quickscanNlp: {
                            id: uuid
                        }
                    }));
                }
            });
            if (engineTypes.length === 1 && engineTypes[0] === SearchEngineTypeValue.INTERNET_SEARCH) {
                _this.snackBar.success("\n              " + _this.translateService.instant('quick_scan.message.quick_scan_for') + "\n              " + _this.name + " " + _this.translateService.instant('quick_scan.message.is_done') + "\n            ");
            }
            else {
                _this.snackBar.success("\n              " + _this.translateService.instant('quick_scan.message.quick_scan_for') + "\n              " + _this.name + " " + _this.translateService.instant('quick_scan.message.is_in_progress') + "\n            ");
            }
        }), concatMap(function (_a) {
            var currentDomain = _a[0], nlpEnabled = _a[1];
            var reqObj = {
                name: _this.name,
                recordType: _this.selectedCustomerType,
                scanEngines: screeningsToBeDone,
                domains: [currentDomain.id],
                extraData: JSON.stringify({ uuid: uuid })
            };
            return _this.quickScansService
                .createQuickScan(reqObj)
                .pipe(takeUntil(_this.unsubscribe$));
        }))
            .subscribe(function (newQuickScan) {
            _this.isLoading = false;
            _this.router.navigateByUrl("/quick-scan/" + newQuickScan.id);
            _this.cdf.detectChanges();
        }, function (error) {
            _this.isLoading = false;
            _this.snackBar.error(error.message || error);
            _this.cdf.detectChanges();
        });
    };
    /**
     * Check search engine credit
     * @method checkBalance
     */
    QuickScanCardComponent.prototype.checkBalance = function () {
        var _this = this;
        var selectedEngineNames = this.selectedEngines.split(',')
            .map(function (selectedEngine) { return _this.screeningService.getSearchEngineLabel(selectedEngine).toLowerCase(); });
        this.store.select(Selectors.billable.getSubscribedButNoCreditEngines)
            .pipe(takeUntil(this.unsubscribe$), take(1))
            .subscribe(function (noCreditSearchEngines) {
            var selectedNoCreditEngines = noCreditSearchEngines.filter(function (noCreditSearchEngine) {
                return selectedEngineNames.includes(noCreditSearchEngine.toLowerCase());
            });
            if (selectedNoCreditEngines.length) {
                _this.openNoCreditWarningDialog(selectedNoCreditEngines);
            }
            else {
                _this.quickScan();
            }
        });
    };
    return QuickScanCardComponent;
}());
export { QuickScanCardComponent };
